module.exports = __webpack_public_path__ + "media/images/lesson_7/sebastiao_patins-4ed87d6b0a6e58571c19f4f80d62ccee.png";